import dayjs from 'dayjs';
import { CompanyType, ManagedAccountType } from '@services';
import { getLastModifiedColor, getStatus, removedCellClassName } from '@helpers';
import { COMPANY_TYPE_LABEL, DATE_FORMAT } from '@constants';
import { GridColDef } from '@mui/x-data-grid';

import { Chip, Typography } from '@mui/material';
import { InfoCell, UserPaymentStatus } from '@atoms';
import { renderPlanCell } from '@molecules/Table/cells';

export const columns: GridColDef<ManagedAccountType>[] = [
  {
    field: 'companyName',
    headerName: 'Company name',
    minWidth: 250,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: ({ row: { companyName, email, logo } }) => (
      <InfoCell name={companyName} email={email} avatarUrl={logo || ''} />
    ),
  },
  {
    field: 'companyType',
    headerName: 'Company type',
    minWidth: 80,
    flex: 1,
    sortable: false,
    cellClassName: removedCellClassName,
    renderCell: ({ value }) => COMPANY_TYPE_LABEL[value as CompanyType],
  },
  {
    field: 'plan',
    headerName: 'Plan',
    minWidth: 80,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: renderPlanCell,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 130,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: ({ row: { status, plan, isRemoved, freeTrialEffectiveDate } }) => {
      const isFreeTrial = freeTrialEffectiveDate
        ? dayjs(freeTrialEffectiveDate).isAfter(dayjs())
        : false;
      const paymentStatus = getStatus(status, plan, isRemoved, isFreeTrial);
      return <UserPaymentStatus status={paymentStatus} />;
    },
  },
  {
    field: 'foundDeleted',
    headerName: 'Links found / deleted',
    minWidth: 200,
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    cellClassName: removedCellClassName,
    sortable: false,
    renderCell: ({
      row: {
        links: { found, deleted },
      },
    }) => (
      <>
        <Typography variant="subtitle2" color="error.main">
          {found}
        </Typography>
        <Typography ml="3px" mr="3px" variant="subtitle2" color="text.disabled">
          /
        </Typography>
        <Typography variant="subtitle2" color="success.main">
          {deleted}
        </Typography>
      </>
    ),
  },
  {
    field: 'lastScanningDate',
    headerName: 'Last Scanning',
    minWidth: 140,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: ({ value }) =>
      value ? (
        <Chip label={dayjs(value).format(DATE_FORMAT)} color={getLastModifiedColor(value)} />
      ) : (
        <Typography color="text.disabled">No scanning</Typography>
      ),
  },
  {
    field: 'joinDate',
    headerName: 'Join date',
    minWidth: 110,
    flex: 1,
    cellClassName: removedCellClassName,
    renderCell: ({ row: { joinDate } }) => dayjs(joinDate).format(DATE_FORMAT),
  },
];
